export default __webpack_public_path__ + "static/media/monkeys-club.c1e20713.png";